import { FC } from 'react'
import { ArrowLeftIcon, XIcon } from 'lucide-react'
import { setShowLessonSidebar, useAppDispatch, useAppSelector } from '../../../redux'
import { getCourseLessonCount, getLessonIndex, useIsMobile } from '../../../utils'
import { StyledLessonSidebarExpand } from '.'

const LessonSidebarExpand: FC = () => {
  const dispatch = useAppDispatch()
  const { isMobile } = useIsMobile()
  const { lesson, course, showSidebar } = useAppSelector((state) => state.course)

  if (showSidebar === true) {
    return null
  }

  if (!isMobile && showSidebar === undefined) {
    return null
  }

  return (
    <StyledLessonSidebarExpand onClick={() => dispatch(setShowLessonSidebar(true))}>
      {isMobile && (
        <>
          <div>
            Lesson {getLessonIndex(lesson, course) + 1}/{getCourseLessonCount(course)}
          </div>
          <div>Open</div>
        </>
      )}
      {!isMobile && <ArrowLeftIcon />}
    </StyledLessonSidebarExpand>
  )
}

export default LessonSidebarExpand
